import { render } from "./FAQEdit.vue?vue&type=template&id=268b325e&scoped=true&ts=true"
import script from "./FAQEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./FAQEdit.vue?vue&type=script&setup=true&lang=ts"

import "./FAQEdit.vue?vue&type=style&index=0&id=268b325e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268b325e"],['__file',"src/components/scan/admin/FAQEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "268b325e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('268b325e', __exports__)) {
    console.log('reload')
    api.reload('268b325e', __exports__)
  }
  
  module.hot.accept("./FAQEdit.vue?vue&type=template&id=268b325e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('268b325e', render)
  })

}


export default __exports__